import { CircularProgress } from "@mui/joy";
import {FullScreenCentered} from "@/components/FullScreenCentered.jsx";

export function FullScreenLoader() {
  return (
    <FullScreenCentered>
      <CircularProgress />
    </FullScreenCentered>
  );
}